// extracted by mini-css-extract-plugin
export default {"empty":"contentempty_empty__CBO+Z","emptyText":"contentempty_emptyText__hlrkV"};